import Button, { ButtonProps } from "@mui/joy/Button";
import { Link } from "react-router-dom";

interface Props extends ButtonProps {
  to: string | number;
  target?: string;
  children: React.ReactNode;
}

const LinkButton = ({ to, children, target, ...props }: Props) => {
  return (
    <Button color="primary" component={Link} to={to} {...props} target={target}>
      {children}
    </Button>
  );
};
export default LinkButton;
